document.addEventListener("alpine:init", () => {
  // Gift Wrapping Validation Store
  Alpine.store("giftWrappingValidation", {
    hasWrappingItems: false,
    wrappingNoteRequired: false,
    wrappingNoteValue: "",
    isCheckoutDisabled: false,

    init() {
      // Delay initial check to ensure DOM is fully loaded
      setTimeout(() => {
        this.checkWrappingItems();
        this.getCurrentWrappingNote();
        this.updateCheckoutState();
      }, 100);
    },

    checkWrappingItems() {
      // Check if any cart items contain 'WRAPPING'
      const cartItems = document.querySelectorAll("[data-cart-item-key]");
      this.hasWrappingItems = false;

      cartItems.forEach((item) => {
        const titleElement = item.querySelector("[data-item-title]");
        if (
          titleElement &&
          titleElement.getAttribute("data-item-title").includes("WRAPPING")
        ) {
          this.hasWrappingItems = true;
        }
      });

      this.wrappingNoteRequired = this.hasWrappingItems;
    },

    getCurrentWrappingNote() {
      // Get current value from textarea if it exists
      const textarea = document.getElementById("GiftWrappingInstructions");
      if (textarea) {
        this.wrappingNoteValue = (textarea.value || "").trim();
      } else {
        this.wrappingNoteValue = "";
      }
    },

    setWrappingNote(value) {
      this.wrappingNoteValue = (value || "").trim();
      this.updateCheckoutState();
    },

    updateCheckoutState() {
      if (this.wrappingNoteRequired && this.wrappingNoteValue === "") {
        this.isCheckoutDisabled = true;
      } else {
        this.isCheckoutDisabled = false;
      }
    },

    refreshState() {
      this.checkWrappingItems();
      this.getCurrentWrappingNote();
      this.updateCheckoutState();
    },
  });

  // Gift Wrapping Note Component
  Alpine.data("ThemeModule_GiftWrappingNote", () => {
    return {
      updating: false,
      init() {
        // Initialize the store with current value after a short delay to ensure store is ready
        this.$nextTick(() => {
          const currentValue = this.$root.value || "";
          if (Alpine.store("giftWrappingValidation")) {
            Alpine.store("giftWrappingValidation").setWrappingNote(
              currentValue,
            );
            Alpine.store("giftWrappingValidation").refreshState();
          }
        });
      },
      updateCartAttributes() {
        this.updating = true;

        // Update the validation store with current value
        if (Alpine.store("giftWrappingValidation")) {
          Alpine.store("giftWrappingValidation").setWrappingNote(
            this.$root.value || "",
          );
        }

        fetch(theme.routes.cart_update_url, {
          method: "POST",
          body: JSON.stringify({
            attributes: {
              "Gift wrapping": this.$root.value,
            },
          }),
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;",
            Accept: "application/json",
          },
        }).then(() => {
          this.updating = false;
        });
      },
    };
  });

  // Initialize the store when DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    if (Alpine.store("giftWrappingValidation")) {
      Alpine.store("giftWrappingValidation").init();
    }
  });
});
